import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const LottieWrapper = ({ animationData, width, height }) => {
  const htmlElementRef = useRef(null);
  const lottieJsonInstance = useRef();

  useEffect(() => {
    if (htmlElementRef.current) {
      lottieJsonInstance.current = lottie.loadAnimation({
        animationData,
        container: htmlElementRef.current,
      });
    }
    return () => {
      lottieJsonInstance.current?.destroy();
    };
  }, [animationData]);

  return <div style={{ width, height }} ref={htmlElementRef}></div>;
};

export default LottieWrapper;
